import {CheckCircleOutlined, NotInterested} from "@mui/icons-material";
import {Box} from "@mui/material";

const ResultIconLogRenderer = ({data, onOpenDetailLog}) => {
    const detailLog = async (data) => {
        onOpenDetailLog(data.pagoId);
    }

    return (
        <Box paddingTop={'3px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            {data.envioOperam === true &&
                <CheckCircleOutlined color="success"/>
            }
            {data.envioOperam === false &&
                <NotInterested color="error" style={{cursor: 'pointer'}} onClick={()=> detailLog(data)} />
            }
        </Box>

    )
}

export default ResultIconLogRenderer
